import { createContext, useContext } from 'react';

// ההתחברות לכל האתר (ZolBakfarApp מספק את הערכים).
// user: { firstName, lastName } או null (גולש לא מחובר — יכול לחפש ולצפות).
// requireLogin(reason, action): פעולות שדורשות התחברות (עדכון מחיר, פידבק). מחובר → action() מיד;
//   לא מחובר → חלון כניסה עם reason, ואחרי ההתחברות action() רץ.
// logout(): יציאה.
// updateUser(patch): אחרי עדכון פרטים בפרופיל — { firstName, lastName }.
export const AuthContext = createContext({
  user: null,
  requireLogin: (reason, action) => action && action(),
  logout: () => {},
  updateUser: () => {},
});

export const useAuth = () => useContext(AuthContext);
